import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createDashboardEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackDashboardOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.DASHBOARD_OPEN,
      properties: { source },
    });

  return { trackDashboardOpen };
};
